import React, { ReactElement } from 'react';
import { CreateInstitutionForm } from './components/CreateInstitutionForm/component';
import { Container, Heading, Form, Image } from './styles';
import ImageCreateInstitution from './images/ImageCreateInstitution.png';

type CreateInstitutionPageProps = {
  onPortalCreated: (name: string) => void;
};

export const CreateInstitutionPage = ({
  onPortalCreated,
}: CreateInstitutionPageProps): ReactElement => {
  return (
    <Container>
      <Form>
        <Heading>Create an institute</Heading>
        <CreateInstitutionForm onPortalCreated={onPortalCreated} />
      </Form>
      <Image>
        <img src={ImageCreateInstitution} alt="" />
      </Image>
    </Container>
  );
};
